import { z } from "zod";
import { linkTokenHashSchema } from "./linkTokenHashSchema";

const RequestUploadFileDtoSchema = z.object({
    id: z.string().nullish(),
    fileId: z.string().nullish(),
    fileName: z.string().nullish(),
    fileExtension: z.string().nullish(),
    fileChunk: z.unknown(),
    size: z.number(),
    taxonomyId: z.number().nullish(),
});

export const UploadIdCardPublicInputSchema = z.object({
    userName: z.string().nullish(),
    requestId: z.string().min(1),
    isUploadFinished: z.boolean().nullish(),
    uploadSessionId: z.string().nullish(),
    fileToUpload: RequestUploadFileDtoSchema,
    linkTokenHash: linkTokenHashSchema,
});

export type UploadIdCardPublicInput = z.infer<typeof UploadIdCardPublicInputSchema>;
